export const NOTIFICATION_TYPE_1 = 'NOTIFICATION_TYPE_1';
export const NOTIFICATION_TYPE_2 = 'NOTIFICATION_TYPE_2';
export const NOTIFICATION_TYPE_3 = 'NOTIFICATION_TYPE_3';
export const NOTIFICATION_TYPE_4 = 'NOTIFICATION_TYPE_4';
export const NOTIFICATION_TYPE_5 = 'NOTIFICATION_TYPE_5';
export const NOTIFICATION_TYPE_6 = 'NOTIFICATION_TYPE_6';
export const NOTIFICATION_TYPE_7 = 'NOTIFICATION_TYPE_7';
export const NOTIFICATION_TYPE_8 = 'NOTIFICATION_TYPE_8';

export const NOTIFICATION_TYPE = {
  [NOTIFICATION_TYPE_1]: '障害発生',
  [NOTIFICATION_TYPE_2]: '障害解消',
  [NOTIFICATION_TYPE_3]: 'メンテナンス',
  [NOTIFICATION_TYPE_4]: '仕様変更',
  [NOTIFICATION_TYPE_5]: 'サポート情報',
  [NOTIFICATION_TYPE_6]: 'アップデート',
  [NOTIFICATION_TYPE_7]: 'お役立ち',
  [NOTIFICATION_TYPE_8]: 'その他',
};

export const DISPLAY_NOTIFICATION_CRITICAL = 'critical';
export const DISPLAY_NOTIFICATION_WARNING = 'warning';
export const DISPLAY_NOTIFICATION_INFO = 'info';

export const TOOLTIP_TYPE = {
  CRITICAL: () => 'お客様にて対応が必要なお知らせがあります',
  WARNING: (message) => `新着のお知らせ「${message}」が届きました`,
  INFO: (message) => `未読のお知らせが${message}件あります`,
};
